import { fg } from '@atlassian/jira-feature-gating';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useApplicationPermissions } from '@atlassian/jira-tenant-context-controller/src/components/application-permissions/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import { UNLICENSED } from '@atlassian/jira-shared-types/src/edition.tsx';

export const useShowCustomerServiceAnalytics = (): boolean => {
	const isAdmin = useIsAdmin();
	const { hasServiceDeskAccess, hasCustomerServiceAccess } = useApplicationPermissions();
	const { customerService } = useAppEditions();

	if (fg('csm_reporting_premission_kill_switch')) {
		if (customerService === UNLICENSED) {
			return false;
		}

		return isAdmin || hasCustomerServiceAccess;
	}
	return fg('jcs-analytics-page') && (isAdmin || hasServiceDeskAccess);
};
